<template>
  <v-slide-x-transition mode="out-in">
    <router-view />
  </v-slide-x-transition>
</template>
<script>
export default {
  created() {
    let lang = { text: "EN", value: "en", dir: "ltr" };
    if (localStorage.getItem("lang")) {
      lang = JSON.parse(localStorage.getItem("lang"));
    } else {
      localStorage.setItem("lang", JSON.stringify(lang));
    }

    this.$i18n.locale = lang.value;
    this.$store.commit("setLang", lang);
    this.$validator.localize(lang.value);
    this.$vuetify.rtl = lang.dir == "rtl";
    this.$vuetify.lang.current = lang.value;
    localStorage.setItem("lang", JSON.stringify(lang));
  }
};
</script>
